import { Breakpoint, Button, DialogActions, DialogContent, DialogTitle, SxProps, Theme } from '@mui/material';
import { ReactNode, SyntheticEvent } from 'react';
import { ButtonsSettings, StyledDialog } from 'components/dialog/Dialog.styles.tsx';

export type Props = {
  open: boolean;
  title?: string;
  onConfirm?: () => void;
  children: ReactNode;
  onCancel?: () => void;
  buttonsSettings?: ButtonsSettings;
  maxWidth?: Breakpoint | false;
  fullWidth?: boolean;
  contentSx?: SxProps<Theme>;
};
const InfoDialog = ({
  children,
  open,
  title,
  onConfirm,
  onCancel,
  buttonsSettings,
  maxWidth = false,
  fullWidth,
  contentSx,
}: Props) => {
  const handleConfirm = (event: SyntheticEvent) => {
    event.stopPropagation();
    onConfirm?.();
  };
  return (
    <StyledDialog
      open={open}
      onClose={onCancel}
      maxWidth={maxWidth}
      fullWidth={fullWidth}
      onClick={(e) => e.stopPropagation()}
    >
      <DialogTitle>{title}</DialogTitle>
      <DialogContent sx={contentSx}>{children}</DialogContent>
      <DialogActions>
        <Button variant="contained" color={buttonsSettings?.confirmColor ?? 'primary'} onClick={handleConfirm}>
          {buttonsSettings?.confirmText ?? 'Ok'}
        </Button>
      </DialogActions>
    </StyledDialog>
  );
};

export default InfoDialog;
